<template>
   <!-- more actions tab -->
  <transition name="slide-up">
    <section v-if="isPopupOpen" class="bg-white rounded-lg shadow-xl border border-purple-100 absolute mt-10 p-4 z-40 right-0 w-60">
      <div class="flex space-y-1 flex-col text-sm font-bold text-gray-600">
        <div class="hover:bg-gray-200 rounded-md py-2 px-3 active:bg-gray-100 cursor-pointer select-none flex space-x-1" @click="$emit('setChatRoomInfo')">
          <ion-icon class="text-pink-500  text-2xl table my-auto"  name="chatbox"></ion-icon>
          <h6 class=" table my-auto">Chat Room Information</h6>
        </div>
        <div class="hover:bg-gray-200 rounded-md py-2 px-3 active:bg-gray-100 cursor-pointer select-none flex space-x-1" @click="toggleShareChat(true)">
          <ion-icon class="text-pink-500  text-2xl table my-auto"  name="share-social"></ion-icon>
          <h6 class=" table my-auto">Share Chat</h6>
        </div>
        <div class="hover:bg-gray-200 rounded-md py-2 px-3 active:bg-gray-100 cursor-pointer select-none flex space-x-1" @click="$emit('leaveChatRoom')">
          <ion-icon class="text-pink-500  text-2xl table my-auto"  name="exit"></ion-icon>
          <h6 class=" table my-auto">Leave Chat Room</h6>
        </div>
      </div>
    </section>
  </transition>
  <tab-container tabName="Share Chat Room" :isTabOpened="isShareTabOpen" :willCheckScroll="false" @toggleTab="(toOpen)=>{toggleShareChat(toOpen)}">
    <section>
     <div class="max-w-md mx-auto mt-10">
        <h6 class="text-base text-purple-500 my-3 text-center">Share this link to invite user to <span class="text-pink-500 font-semibold"> {{chatRoom.name}} </span> </h6>
        <div class="flex space-x-2">
          <div class="w-10 h-10 flex rounded-full overflow-hidden my-auto" style="background-color: #B9F6F3">
            <div class="w-7 h-7 rounded-full overflow-hidden m-auto">
              <img :src="chatRoom.icon" class="image-full-size">
            </div>
          </div>
          <div class="bg-red-200 w-full relative"  @click="setCopyShareLink(true)" @mouseleave="setCopyShareLink(false)">
            <transition name="fade">
              <div v-if="isCopyBannerVisible" class="text-xs bg-purple-500 text-white p-2 rounded-lg absolute -top-5 bg-opacity-95 left-1/2 transform -translate-x-1/2 w-max">
                <h6>Copied to clipboard.</h6>
              </div>
            </transition>
            <ion-icon  name="copy" class="absolute top-1/2 transform -translate-y-1/2 right-5 z-20 text-xl text-purple-500"></ion-icon>
            <input type="text" :value="shareLink" readonly class="text-input-default cursor-pointer w-full z-10">
          </div>
          
        </div>
        <div class="py-10">
            <img class="mx-auto max-w-sm opacity-80" src="/modal-images/mail.png" alt="Envelope">
          </div>
     </div>
    </section>
  </tab-container>
  
</template>

<script>
import TabContainer from '@/components/TabContainer.vue';

export default {
  data(){
    return {
      isPopupOpen : false,
      isShareTabOpen : false,
      isCopyBannerVisible : false
    }
  },
  emits : ['leaveChatRoom','setChatRoomInfo'],
  props : {
    chatRoom : Object,
    currentUsersData : Object
  },
  components : {
    'tab-container' : TabContainer
  },
  computed : {
    shareLink(){
      return location.origin + '/#/0/1/0/' +  this.chatRoom.id;
    }
  },
  methods : {
    setCopyShareLink(willCopy){

      if(willCopy)navigator.clipboard.writeText(this.shareLink);
      this.isCopyBannerVisible = willCopy;

    },
    toggleShareChat(toOpen){
      if(toOpen === null)this.isShareTabOpen = !this.isShareTabOpen;
      this.isShareTabOpen = toOpen;
    },
    togglePopupTab(toOpen = null){
      if(toOpen !== null){
        this.isPopupOpen = toOpen;
        return;
      }
      this.isPopupOpen = !this.isPopupOpen;
    },
    
  },
}
</script>
